import { EditPersonalizationEvent } from './edit-personalization.schema';
import { EntityContactPersonSchema } from './entity-contact-person.schema';
import { EntityDownloadSchema } from './entity-download.schema';
import { EntityEventSchema } from './entity-event.schema';
import { EntityExhibitorSchema } from './entity-exhibitor.schema';
import { EntityPostSchema } from './entity-post.schema';
import { EntityProductSchema } from './entity-product.schema';
import { GalleryImpressionSchema } from './gallery-impression.schema';
import { GenerateBusinessCardSchema } from './generate-business-card.schema';
import { InteractWithWatchlistSchema } from './interact-with-watchlist.schema';
import { PageViewSchema } from './page-view.schema';
import { SearchSchema } from './search.schema';
import { ShareSchema } from './share.schema';
import { TabClickSchema } from './tab-click.schema';
import { ViewEntityImpressionsSchema } from './view-entity-impressions.schema';

export type CustomEventEntity =
  | EntityEventSchema
  | EntityExhibitorSchema
  | EntityPostSchema
  | EntityProductSchema
  | EntityContactPersonSchema
  | EntityDownloadSchema
  | PageViewSchema
  | ViewEntityImpressionsSchema
  | SearchSchema
  | ShareSchema
  | TabClickSchema
  | EditPersonalizationEvent
  | GalleryImpressionSchema
  | InteractWithWatchlistSchema
  | GenerateBusinessCardSchema;

export enum CustomEventIglu {
  entity_event = 'iglu:com.planone/entity_event/jsonschema/1-0-0',
  entity_exhibitor = 'iglu:com.planone/entity_exhibitor/jsonschema/2-0-0',
  entity_post = 'iglu:com.planone/entity_post/jsonschema/1-0-0',
  entity_product = 'iglu:com.planone/entity_product/jsonschema/1-0-0',
  entity_contact_person = 'iglu:com.planone/entity_contact_person/jsonschema/1-0-0',
  entity_download = 'iglu:com.planone/entity_download/jsonschema/1-0-0',
  page_view = 'iglu:com.planone/page_view/jsonschema/1-0-0',
  share = 'iglu:com.planone/share/jsonschema/1-0-2',
  link_click_additions = 'iglu:com.planone/link_click_additions/jsonschema/1-0-3',
  search = 'iglu:com.planone/search/jsonschema/4-0-1',
  view_entity_impressions = 'iglu:com.planone/view_entity_impressions/jsonschema/2-0-0',
  tab_click = 'iglu:com.planone/tab_click/jsonschema/1-0-0',
  gallery_impression = 'iglu:com.planone/gallery_impression/jsonschema/1-0-1',
  edit_personalization = 'iglu:com.planone/edit_personalization/jsonschema/1-0-0',
  interact_with_watchlist = 'iglu:com.planone/interact_with_watchlist/jsonschema/1-0-0',
  export = 'iglu:com.planone/export/jsonschema/1-0-1',
  subscribe = 'iglu:com.planone/subscribe/jsonschema/1-0-0',
  generate_business_card = 'iglu:com.planone/generate_business_card/jsonschema/1-0-1',
}

export enum SocialNetworkMapping {
  facebook = 'FACEBOOK',
  linkedin = 'LINKED_IN',
  xing = 'XING',
  x = 'X',
  pinterest = 'PINTEREST',
  email = 'MAIL',
  print = 'PRINT',
  copy = 'LINK_COPY',
  FACEBOOK = 'FACEBOOK',
  LINKED_IN = 'LINKED_IN',
  XING = 'XING',
  PINTEREST = 'PINTEREST',
  MAIL = 'MAIL',
  PRINT = 'PRINT',
  LINK_COPY = 'LINK_COPY',
  X = 'X',
}

export interface CustomEventEntitySchematic {
  schema: CustomEventIglu;
  data: CustomEventEntity;
}

export interface CustomEventItem {
  event: CustomEventEntitySchematic;
  context: CustomEventEntitySchematic[];
}

export interface CustomEventQueueItem extends CustomEventItem {
  trackerId?: string;
  triggered_at: number;
}

export interface PageViewQueueItem {
  trackerId?: string;
  title: string;
  triggered_at: number;
  context: CustomEventEntitySchematic[];
}
